/* eslint-disable no-console */
import { debugBus } from "./debug/bus";

export class Logger {
  private _debug: boolean;
  private _prefix: string;

  constructor(prefix: string) {
    this._debug = false;
    this._prefix = prefix;
  }

  set debug(value: boolean) {
    this._debug = value;
  }

  public printDebug(...args: unknown[]): void {
    debugBus.push({
      kind: "log",
      prefix: this._prefix,
      level: "debug",
      args,
      ts: Date.now(),
    });
    if (!this._debug) return;
    console.debug(`[DQ] ${this._prefix}:`, ...args);
  }

  public printError(...args: unknown[]): void {
    debugBus.push({
      kind: "log",
      prefix: this._prefix,
      level: "error",
      args,
      ts: Date.now(),
    });
    console.error(`[DQ] ${this._prefix}:`, ...args);
  }
}
